import { cn } from "@/lib";
import React, { ComponentProps, FC } from "react";

export const maxWidth = "max-w-[1340px]";
const AppContainer: FC<ComponentProps<"div">> = ({ children, ...props }) => {
  return (
    <div
      {...props}
      className={cn(
        "mx-auto",
        "h-screen",
        "px-8 lg:px-4",
        "w-full",
        maxWidth,
        props.className,
      )}
    >
      {children}
    </div>
  );
};

export default AppContainer;
